import React, { useState, useEffect } from "react"
import { CheckmarkIcon, XmarkIcon } from "../Icons/small"
import Ajv from "ajv"

export const EVergabeEventSignupModal = ({
  modal_open,
  close_modal,
  event,
}) => {
  const { price, title, date } = event

  const SALES_CHANNEL_ENUM = [
    { label: "E-Mail", value: "email" },
    { label: "Webseite", value: "website" },
    { label: "Kollegen", value: "colleague" },
    { label: "Andere", value: "other" },
  ]
  const [accepted_tos, set_accepted_tos] = useState(false)
  const toggle_accepted_tos = () => set_accepted_tos(!accepted_tos)

  const [signup_data, set_signup_data] = useState(null)

  const update_signup_data = ({ updated_field, new_value }) => {
    set_signup_data({ ...signup_data, [updated_field]: new_value })
  }

  const update_name = (e) =>
    update_signup_data({ updated_field: "name", new_value: e.target.value })

  const update_email = (e) =>
    update_signup_data({ updated_field: "email", new_value: e.target.value })

  const update_employer = (e) =>
    update_signup_data({ updated_field: "employer", new_value: e.target.value })

  const update_street = (e) =>
    update_signup_data({ updated_field: "street", new_value: e.target.value })

  const update_house_number = (e) =>
    update_signup_data({
      updated_field: "house_number",
      new_value: e.target.value,
    })
  const update_city = (e) =>
    update_signup_data({
      updated_field: "city",
      new_value: e.target.value,
    })
  const update_zipcode = (e) =>
    update_signup_data({
      updated_field: "zipcode",
      new_value: e.target.value,
    })
  const update_alt_billing_address = (e) =>
    update_signup_data({
      updated_field: "alt_billing_address",
      new_value: e.target.value,
    })
  const update_sales_channel = (value) =>
    update_signup_data({
      updated_field: "sales_channel",
      new_value: value,
    })

  const ERROR_MAPPING = {
    name: "Name",
    email: "E-Mail",
    employer: "Firma / Verband / Behörde",
    street: "Straße",
    house_number: "Hausnummer",
    city: "Ort",
    zipcode: "PLZ",
  }
  const [is_valid_signup, set_is_valid_signup] = useState(false)
  const [validation_errors, set_validation_errors] = useState(null)

  const validate_signup_data = () => {
    const ajv = new Ajv({ allErrors: true })
    const schema = {
      type: "object",
      properties: {
        name: {
          type: "string",
        },
        email: {
          type: "string",
        },
        employer: {
          type: "string",
        },
        street: {
          type: "string",
        },
        house_number: {
          type: "string",
        },
        city: {
          type: "string",
        },
        zipcode: {
          type: "string",
        },
      },
      required: [
        "name",
        "email",
        "employer",
        "street",
        "house_number",
        "city",
        "zipcode",
      ],
      additionalProperties: true,
    }
    const validate = ajv.compile(schema)
    const data_to_validate = {
      ...signup_data,
    }
    if (validate(data_to_validate)) {
      set_is_valid_signup(true)
    } else {
      set_is_valid_signup(false)
      set_validation_errors(validate.errors)
    }
  }

  useEffect(() => {
    validate_signup_data()
  }, [JSON.stringify(signup_data)]) // eslint-disable-line

  const [req_loading, set_req_loading] = useState(false)

  const [resp_ok, set_resp_ok] = useState(null)

  const retry = () => {
    set_req_loading(false)
    set_resp_ok(null)
  }
  const send_signup = () => {
    set_req_loading(true)
    fetch(
      "https://europe-west3-biwebsite.cloudfunctions.net/create_evergabe_event_signup",
      {
        method: "POST",
        body: JSON.stringify({
          event,
          attendee_data: signup_data,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((resp) => {
        set_req_loading(false)
        set_resp_ok(resp.ok)
      })
      .catch((error) => {
        console.log(error)
        set_req_loading(false)
        set_resp_ok(null)
      })
  }

  const close_and_reset_modal = () => {
    retry()
    set_accepted_tos(false)
    set_signup_data(null)
    close_modal()
  }
  return (
    <div className={`modal ${modal_open ? "is-active" : ""}`}>
      <div className="modal-background"></div>
      <button
        onClick={close_modal}
        className="modal-close is-large"
        aria-label="close"
      ></button>
      <div className="modal-content is-flex" style={{ width: 815 }}>
        <div
          className="box m-auto is-flex is-flex-direction-column"
          style={{ width: 800, minHeight: 300 }}
        >
          <p className="title is-4 has-text-mitternachtsblau mb-0">
            Anmeldung zum Seminar: {title}
          </p>
          <div className="is-flex mb-2">
            <p className="has-text-mitternachtsblau">
              <span className="subtitle is-7">Datum:</span>
              <span className="title is-7 ml-2">
                {new Intl.DateTimeFormat("de-DE", {
                  timeZone: "Europe/Berlin",
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(date))}{" "}
                Uhr
              </span>
            </p>
            <p className="has-text-mitternachtsblau ml-4">
              <span className="subtitle is-7">Teilnahmegebühr:</span>
              <span className="title is-7 ml-2">{price} €</span>
              <span className="help ml-2" style={{ display: "inline-block" }}>
                zzgl. MwSt.
              </span>
            </p>
          </div>
          {req_loading ? (
            <div className="is-flex is-flex-direction-column mb-6">
              <p className="title is-5 my-6 has-text-centered has-text-mitternachtsblau">
                Anfrage wird bearbeitet, einen Moment bitte...
              </p>
              <div className="spinner m-auto"></div>
            </div>
          ) : resp_ok ? (
            <div className="is-flex is-flex-direction-column">
              <p className="title is-5 mt-6 mb-5 has-text-centered has-text-mitternachtsblau">
                Anfrage erfolgreich, wir freuen uns auf Ihre Teilnahme!
              </p>

              <div
                className="mx-auto mb-5"
                style={{
                  display: "flex",
                  width: 82,
                  height: 82,
                  backgroundColor: "#0EAA2D30",
                  borderRadius: "100%",
                }}
              >
                <CheckmarkIcon
                  {...{ className: "m-auto", size: 2, color: "#0EAA2D" }}
                />
              </div>
              <p className="has-text-centered has-text-mitternachtsblau mb-5">
                Bitte prüfen Sie Ihr E-Mail Postfach nach einer
                Anmeldebestätigung.
              </p>
              <div className="buttons ml-auto mt-4">
                <button
                  onClick={close_and_reset_modal}
                  className="button is-sonnengelb has-text-weight-bold"
                >
                  Schließen
                </button>
              </div>
            </div>
          ) : resp_ok !== null ? (
            <div className="is-flex is-flex-direction-column">
              <p className="title is-5 mt-6 has-text-centered has-text-mitternachtsblau">
                Anfrage leider nicht erfolgreich.
              </p>
              <div
                className="mx-auto mb-5"
                style={{
                  display: "flex",
                  width: 82,
                  height: 82,
                  backgroundColor: "#E7002330",
                  borderRadius: "100%",
                }}
              >
                <XmarkIcon
                  {...{ className: "m-auto", size: 1.2, color: "#E70023" }}
                />
              </div>
              <p className="has-text-centered has-text-mitternachtsblau mb-6">
                Bitte probieren Sie es erneut, oder wenden Sie sich an unseren
                Kundenservice
              </p>
              <div className="buttons ml-auto mt-4">
                <button
                  onClick={close_and_reset_modal}
                  className="button is-tertiary has-text-weight-bold"
                >
                  Schließen
                </button>
                <button
                  onClick={retry}
                  className="button is-sonnengelb has-text-weight-bold"
                >
                  Erneut versuchen
                </button>
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div className="control has-label">
                <input
                  type="text"
                  className="input"
                  placeholder="Vor- und Nachname"
                  onChange={update_name}
                />
                <label htmlFor="title-input">Vor- und Nachname</label>
              </div>
              <div className="control has-label mt-4">
                <input
                  type="text"
                  className="input"
                  placeholder="E-Mail"
                  onChange={update_email}
                />
                <label htmlFor="title-input">E-Mail</label>
              </div>
              <div className="control has-label mt-4">
                <input
                  type="text"
                  className="input"
                  placeholder="Firma / Verband / Behörde"
                  onChange={update_employer}
                />
                <label htmlFor="title-input">Firma / Verband / Behörde</label>
              </div>
              <div className="is-flex mt-4">
                <div
                  className="control has-label mr-4"
                  style={{ width: "70%" }}
                >
                  <input
                    type="text"
                    className="input"
                    placeholder="Straße"
                    onChange={update_street}
                  />
                  <label htmlFor="title-input">Straße</label>
                </div>
                <div className="control has-label" style={{ width: "auto" }}>
                  <input
                    type="text"
                    className="input"
                    placeholder="Hausnr"
                    onChange={update_house_number}
                  />
                  <label htmlFor="title-input">Hausnr</label>
                </div>
              </div>
              <div className="is-flex my-4">
                <div
                  className="control has-label mr-4"
                  style={{ width: "auto" }}
                >
                  <input
                    type="text"
                    className="input"
                    placeholder="PLZ"
                    onChange={update_zipcode}
                  />
                  <label htmlFor="title-input">PLZ</label>
                </div>
                <div className="control has-label" style={{ width: "70%" }}>
                  <input
                    type="text"
                    className="input"
                    placeholder="Ort"
                    onChange={update_city}
                  />
                  <label htmlFor="title-input">Ort</label>
                </div>
              </div>
              <div className="control has-label">
                <input
                  type="text"
                  className="multiline-input"
                  placeholder="Abweichende Rechnungsadresse"
                  onChange={update_alt_billing_address}
                />
                <label htmlFor="title-input">
                  Abweichende Rechnungsadresse
                </label>
              </div>
              <div className="my-2">
                <p className="title is-7 has-text-mitternachtsblau mb-2 mt-3">
                  Ich habe die Teilnahmebedingungen verstanden und akzeptiert.
                </p>
                <div className="is-flex">
                  <div
                    className="is-flex checkbox-item mr-2 is-clickable"
                    style={{
                      backgroundColor: "transparent",
                    }}
                    onClick={toggle_accepted_tos}
                    aria-label="use checkbox"
                    role="button"
                    tabIndex="-1"
                    onKeyDown={toggle_accepted_tos}
                  >
                    <div
                      className={`checkbox${accepted_tos ? " is-refined" : ""}`}
                    ></div>
                    <span
                      style={{ fontSize: 18 }}
                      className="my-auto has-text-mitternachtsblau is-clickable has-text-left"
                    >
                      Teilnahmebedingungen akzeptieren
                    </span>
                  </div>
                </div>
              </div>
              <div className="my-2">
                <p className="title is-7 has-text-mitternachtsblau mb-2 mt-3">
                  Wie haben Sie von diesem Seminar erfahren?
                </p>
                <div className="is-flex">
                  {SALES_CHANNEL_ENUM.map(({ label, value }, index) => {
                    const is_refined = signup_data?.sales_channel === value
                    const toggle_selection = () => update_sales_channel(value)
                    return (
                      <div
                        className="is-flex checkbox-item mr-2 is-clickable"
                        style={{
                          width: `${100 / SALES_CHANNEL_ENUM.length}%`,
                          backgroundColor: "transparent",
                        }}
                        key={label + index}
                        onClick={toggle_selection}
                        aria-label="use checkbox"
                        role="button"
                        tabIndex="-1"
                        onKeyDown={toggle_selection}
                      >
                        <div
                          className={`checkbox${
                            is_refined ? " is-refined" : ""
                          }`}
                        ></div>
                        <span
                          style={{ fontSize: 18 }}
                          className="my-auto has-text-mitternachtsblau is-clickable has-text-left"
                        >
                          {label}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
              <p className="help has-text-mitternachtsblau is-underlined mt-2">
                Teilnahmebedingungen:
              </p>
              <p className="help has-text-mitternachtsblau mb-3">
                Für die Teilnahme benötigen Sie eine E-Mail-Adresse mit Zugang
                zu Microsoft-Teams, sowie eine stabile Internetverbindung und
                ein videokonferenz-fähiges Gerät mit Ton-Ausgabe. Die Anmeldung
                zu einem jeweiligen Termin muss bis spätestens 24 Std. vor der
                Veranstaltung stattgefunden haben. Bei späteren Anmeldungen
                können wir die Teilnahme nicht garantieren.
              </p>
              <div
                className="is-flex has-background-white"
                style={{ position: "sticky", bottom: 0 }}
              >
                <div className="buttons ml-auto mt-4">
                  <button
                    onClick={close_and_reset_modal}
                    className="button is-tertiary has-text-weight-bold"
                  >
                    Schließen
                  </button>
                  <div className="has-tooltip mx-3">
                    <button
                      disabled={!is_valid_signup || !accepted_tos}
                      onClick={send_signup}
                      className="button is-sonnengelb has-text-weight-bold"
                    >
                      Anmelden
                    </button>
                    {!accepted_tos ? (
                      <div
                        className="tooltip-content"
                        style={{
                          width: "100%",
                          top: -72,
                        }}
                      >
                        <p className="mb-2">
                          Bitte Teilnahmebedingungen akzeptieren.
                        </p>
                      </div>
                    ) : !is_valid_signup && !!validation_errors?.[0] ? (
                      <div
                        className="tooltip-content"
                        style={{
                          width: "100%",
                          top: -72 - validation_errors?.length * 20,
                        }}
                      >
                        <p className="has-text-weight-bold mb-2">
                          Fehlende Angaben:
                        </p>
                        <ul>
                          {validation_errors?.map(
                            ({ params: { missingProperty } }, i) => {
                              return (
                                <li
                                  key={"validation_error_" + i}
                                  className="mb-2"
                                >
                                  {ERROR_MAPPING[missingProperty]}
                                </li>
                              )
                            }
                          )}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
